import { createFileRoute } from '@tanstack/react-router';
import { InstallGuide } from '../../pages/InstallGuide';

export const Route = createFileRoute('/_authenticated/install-guide')({
  component: InstallGuide,
});

